// extracted by mini-css-extract-plugin
module.exports = {"PreviewModeBadge":"PreviewModeBadge_PreviewModeBadge__pXY5T","dot":"PreviewModeBadge_dot__htrDB","dotActive":"PreviewModeBadge_dotActive__pohr2"};